import { StatusChip } from "@itandi/itandi-bb-ui/StatusChip";
import type { DealEstimationHeader } from "~/models/DealEstimationHeader";
import { statusLabel, statusVariant } from "~/models/DealEstimationHeader";
import { formatDate } from "~/utils/DateUtil";

type Props = {
	dealEstimationHeader: DealEstimationHeader;
};

export function DealEstimationHeaderStatus({ dealEstimationHeader }: Props) {
	const { status } = dealEstimationHeader;
	if (status === "draft" || status === "accepted_by_system") return null;
	return (
		<>
			<StatusChip variant={statusVariant(status)}>
				{statusLabel(status)}
			</StatusChip>
			{status !== "request" && (
				<p>
					処理日時：
					{formatDate(dealEstimationHeader.processedAt, true)}
				</p>
			)}
		</>
	);
}
